import { Button, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, TextField, Typography, Stack, Box, IconButton, Divider, Alert } from "@mui/material";
import KeyIcon from '@mui/icons-material/Key';
import { useState } from "react";
import { NavLink, Outlet, useLoaderData, useSubmit } from "react-router-dom";
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import api from "../../hooks/useApi";
import AuthProvider from "../../hooks/authProvider";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Grid from '@mui/material/Unstable_Grid2';
import PageTitle from "../../components/PageTitle";
import PasswordField from '../../components/PasswordField';

export async function loader({ request, params }) {
    const user = (await AuthProvider.getUserDetails());
    const form = (await api.get('/api/CreateObjForms/HotelOwner/')).data.form;
    return { user, form };
}
export async function action({ request, params }) {
    const formData = await request.formData();
    try {
        await api.post('/api/user/password/', Object.fromEntries(formData.entries()));
        return { success: true };
    } catch (error) {
        return { error: error.response?.data || { detail: 'Не вдалося змінити пароль.' } };
    }
}

const dict = {
    "email": "Email",
    "name": "Ім'я",
    "last_name": "Прізвище",
    "second_name": "По-батькові",
    "phone": "Телефон",
    "birth_date": "Дата народження",
    "city_of_residence": "Місто",
}

export default function ProfileDetails() {
    const [showModalChangePass, setShowModalChangePass] = useState(false);
    const handleShowModalChangePass = () => setShowModalChangePass(prev => !prev);
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        reset,
        setValue,
    } = useForm();
    const submit = useSubmit();
    const { user } = useLoaderData();
    const closePasswordDialog = () => { reset({ password: '', password_confirm: '' }); setShowModalChangePass(false); };
    const setGeneratedPassword = (value) => {
        setValue('password', value, {shouldValidate: true});
        setValue('password_confirm', value, {shouldValidate: true});
    };
    const profileFields = ['email', 'name', 'last_name', 'second_name', 'phone', 'birth_date', 'city_of_residence'];
    return (
        <>
            <PageTitle title="Профіль: особисті дані" />
            <Dialog open={showModalChangePass} fullWidth maxWidth="sm" onClose={closePasswordDialog}>
                    <DialogTitle sx={{ pr: 6 }}>Зміна пароля
                        <IconButton aria-label="Закрити" onClick={closePasswordDialog} sx={{ position: 'absolute', right: 8, top: 8 }}><CloseIcon /></IconButton>
                    </DialogTitle>
                        <form
                            method="post"
                            onSubmit={(event) => {
                                const target = event.currentTarget
                                handleSubmit(() => {
                                    handleShowModalChangePass();
                                    submit(target, { method: "post" })
                                })(event)
                            }}
                        >
                            <DialogContent dividers><Stack spacing={2} sx={{ pt: 1 }}>
                                    <FormControl
                                        fullWidth>
                                        <PasswordField
                                            name='password'
                                            label='Новий пароль'
                                            value={watch('password') || ''}
                                            onChange={(value) => setValue('password', value, {shouldValidate: true})}
                                            onGenerate={setGeneratedPassword}
                                            register={register('password', {
                                                required: true && "Обов'язкове поле",
                                                minLength: {
                                                    value: 6,
                                                    message: "Мінімальна довжина: 6",
                                                },
                                                maxLength: {
                                                    value: 20,
                                                    message: "Максимальна довжина: 20",
                                                }
                                            })}
                                            error={errors.password !== undefined}
                                            helperText={errors.password ? errors.password.message : ''}
                                        />
                                    </FormControl>
                                <FormControl fullWidth>
                                        <PasswordField
                                            name='password_confirm'
                                            label='Підтвердіть новий пароль'
                                            value={watch('password_confirm') || ''}
                                            onChange={(value) => setValue('password_confirm', value, {shouldValidate: true})}
                                            onGenerate={setGeneratedPassword}
                                            register={register('password_confirm', {
                                                required: true && "Обов'язкове поле",
                                                minLength: {
                                                    value: 6,
                                                    message: "Мінімальна довжина: 6",
                                                },
                                                maxLength: {
                                                    value: 20,
                                                    message: "Максимальна довжина: 20",
                                                },
                                                validate: (val) => {
                                                    if (watch('password') !== val) {
                                                        return "Паролі не збігаються";
                                                    }
                                                },
                                            })}
                                            error={errors.password_confirm !== undefined}
                                            helperText={errors.password_confirm ? errors.password_confirm.message : ''}
                                        />
                                </FormControl>
                            </Stack></DialogContent>
                            <DialogActions sx={{ px: 3, py: 2, flexWrap: 'wrap', gap: 1 }}>
                                <Button onClick={closePasswordDialog}>Скасувати</Button><Button variant='contained' type='submit'>Змінити пароль</Button>
                            </DialogActions>
                        </form>
            </Dialog>
            <Grid container spacing={2}>
                <Grid  container>
                    <Typography variant='h5'>Інформація про користувача:</Typography>
                </Grid>
                <Grid  container spacing={2}>
                    <Grid  container spacing={2} xs={12}>
                        {profileFields.filter((field) => Object.prototype.hasOwnProperty.call(user, field)).map((k) => (
                            <Grid  xs={12} sm={6} key={k}>
                                <ProfileField f={k} v={user[k]} />
                            </Grid>
                        ))}
                    </Grid>
                    <Grid  xs={12}>
                        <Divider />
                    </Grid>
                    <Grid  xs={12}>

                        <Typography variant='p'>Пароль</Typography>
                        <Box sx={{ mt: 2 }}>
                            <Button onClick={handleShowModalChangePass} variant='contained' startIcon={<KeyIcon />}>
                                Змінити пароль
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid >
            <Outlet />
        </>
    )
}

const ProfileField = ({ f, v }) => {
    return (
        <Box>
            <Typography>
                {dict[f]}
            </Typography>
            <Grid container spacing={0.5} sx={{ alignItems: 'center' }}>
                <Grid  xs={10}>
                    <FormControl fullWidth><TextField
                        disabled
                        value={v}
                    /></FormControl>
                </Grid>
                <Grid  xs={2}>
                    <IconButton
                        component={NavLink}
                        to={`/adminH123H/details/${AuthProvider.id}/change/${f}`}
                    >
                        <EditOutlinedIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Box>
    )
}
